module.exports = __webpack_public_path__ + "img/nav_2_0.5dc8e912.gif";